import React from "react";

const MobileProfileSocial: React.FC = () => "MobileProfileSocial";

export default MobileProfileSocial;
